import React, { createContext, useContext, useState } from 'react';

const TourContext = createContext();

export const useTour = () => useContext(TourContext);

export const TourProvider = ({ children }) => {
  const [completedTours, setCompletedTours] = useState(() => {
    // Load from localStorage
    const saved = localStorage.getItem('completedTours');
    return saved ? JSON.parse(saved) : [];
  });

  const markTourComplete = (tourName) => {
    const updated = [...completedTours, tourName];
    setCompletedTours(updated);
    localStorage.setItem('completedTours', JSON.stringify(updated));
  };

  const isTourComplete = (tourName) => {
    return completedTours.includes(tourName);
  };

  const resetAllTours = () => {
    setCompletedTours([]);
    localStorage.removeItem('completedTours');
  };

  return (
    <TourContext.Provider value={{ 
      completedTours, 
      markTourComplete, 
      isTourComplete,
      resetAllTours 
    }}>
      {children}
    </TourContext.Provider>
  );
};


